// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toast-container-responsive {
  position: fixed;
  z-index: 60;
  bottom: 0;
  left: 0;
  width: 100vw;
  overflow: hidden;
}
.toast-container-responsive .notification-box {
  min-height: 0;
  display: inline-block;
  margin-top: 10px;
  transition: all 0.5s ease-in-out;
}
.toast-container-responsive .notification-box.dismissed {
  transform: translateY(100vh);
}
.toast-container-responsive .notification-box .title-container {
  margin-bottom: 20px;
}
.toast-container-responsive .notification-box .title-container .title {
  font-weight: bold;
}
.toast-container-responsive .notification-box .description {
  margin-bottom: 15px;
}
.toast-container-standard {
  position: absolute;
  top: 0;
  right: 0;
  width: 550px;
  padding-right: 76px;
  z-index: 60;
}
.toast-container-standard .notification-box {
  min-height: 66px;
  opacity: 0;
  transition: opacity 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
  margin: 15px;
  display: inline-block;
}
.toast-container-standard .notification-box.show {
  opacity: 1;
}
.toast-container-standard .notification-box .title-container {
  margin-bottom: 5px;
}
.toast-container-standard .notification-box .description {
  margin-bottom: 5px;
}
.notification-box {
  padding: 16px 14px 16px 26px;
  border: 3px solid #7F6C2E;
  color: #444444;
  background-color: #ffffff;
  width: 100%;
}
.notification-box.error {
  border-color: #c30e2e;
}
.notification-box .title-container {
  width: 100%;
}
.notification-box .title-container .title {
  font-family: Montserrat-Regular, sans-serif;
  font-size: 18px;
  text-align: left;
}
.notification-box .title-container .close-circle {
  width: 24px;
  height: 24px;
  object-fit: contain;
  float: right;
  background-image: url('close-circle.ce4097ed45dc398c.svg');
  cursor: pointer;
}
.notification-box .title-container .close-circle:hover {
  background-image: url('close-circle-hover.8122d2f1408175c5.svg');
}
.notification-box .title-container .close-cross {
  width: 24px;
  height: 24px;
  object-fit: contain;
  float: right;
  background-image: url('cross.94f7db39b7176d24.svg');
  cursor: pointer;
}
.notification-box .title-container .close-cross:hover {
  background-image: url('cross-hover.51d99dd21ec0e20c.svg');
}
.notification-box .description {
  width: 100%;
  font-family: Montserrat-Regular, sans-serif;
  font-size: 15px;
  line-height: 1.33;
  text-align: left;
}
.notification-box .subtitle {
  margin-top: 12px;
  font-family: WarnockPro-Regular, serif;
  font-size: 15px;
  text-align: left;
  color: #444444;
  display: inline-block;
  margin-right: 16px;
}
.notification-box .action-wrap {
  display: flex;
  justify-content: flex-end;
  margin: 10px 5px 0 0;
}
.notification-box .action-wrap .action {
  width: 70px;
  height: 35px;
  background-color: #7F6C2E;
  cursor: pointer;
  text-align: center;
}
.notification-box .action-wrap .action .text {
  font-family: WarnockPro-Semibold, serif;
  font-size: 14px;
  line-height: 35px;
  color: #ffffff;
  text-decoration: none;
}
.notification-box .action-wrap .action:hover {
  background-color: #685925;
}
.notification-box.head {
  padding-top: 26px;
}
`, "",{"version":3,"sources":["webpack://./node_modules/proceduralsystem-clientcomponents/components/notifications/toast-notifications/toast-notifications.component.less"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,WAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,gBAAA;AADF;AALA;EASI,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,gCAAA;AADJ;AAGI;EACE,4BAAA;AADN;AAdA;EAmBM,mBAAA;AAFN;AAjBA;EAqBQ,iBAAA;AADR;AApBA;EA0BM,mBAAA;AAHN;AAQA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;AANF;AAAA;EASI,gBAAA;EACA,UAAA;EACA,4DAAA;EACA,YAAA;EACA,qBAAA;AANJ;AAQI;EACE,UAAA;AANN;AAVA;EAoBM,kBAAA;AAPN;AAbA;EAwBM,kBAAA;AARN;AAaA;EACE,4BAAA;EACA,yBAAA;EACA,cAAA;EACA,yBAAA;EACA,WAAA;AAXF;AAaE;EACE,qBAAA;AAXJ;AAGA;EAYI,WAAA;AAZJ;AAAA;EAeM,2CAAA;EACA,eAAA;EACA,gBAAA;AAZN;AALA;EAqBM,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,0DAAA;EACA,eAAA;AAbN;AAeM;EACE,gEAAA;AAbR;AAhBA;EAkCM,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,mDAAA;EACA,eAAA;AAfN;AAiBM;EACE,yDAAA;AAfR;AA3BA;EAgDI,WAAA;EACA,2CAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAlBJ;AAlCA;EAwDI,gBAAA;EACA,sCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;AAnBJ;AA3CA;EAkEI,aAAA;EACA,yBAAA;EACA,oBAAA;AApBJ;AAhDA;EAuEM,WAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;AApBN;AAvDA;EA8EQ,uCAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;AApBR;AAuBM;EACE,yBAAA;AArBR;AAyBE;EACE,iBAAA;AAvBJ","sourcesContent":["@import (reference) '../../../styles/variables.less';\n\n.toast-container-responsive {\n  position: fixed;\n  z-index: 60;\n  bottom: 0;\n  left: 0;\n  width: 100vw;\n  overflow: hidden;\n\n  .notification-box {\n    min-height: 0;\n    display: inline-block;\n    margin-top: 10px;\n    transition: all .5s ease-in-out;\n\n    &.dismissed {\n      transform: translateY(100vh);\n    }\n\n    .title-container {\n      margin-bottom: 20px;\n      .title {\n        font-weight: bold;\n      }\n    }\n\n    .description {\n      margin-bottom: 15px;\n    }\n  }\n}\n\n.toast-container-standard {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 550px;\n  padding-right: 76px;\n  z-index: 60;\n\n  .notification-box {\n    min-height: 66px;\n    opacity: 0;\n    transition: opacity .3s cubic-bezier(.215, .61, .355, 1);\n    margin: 15px;\n    display: inline-block;\n\n    &.show {\n      opacity: 1;\n    }\n\n    .title-container {\n      margin-bottom: 5px;\n    }\n\n    .description {\n      margin-bottom: 5px;\n    }\n  }\n}\n\n.notification-box {\n  padding: 16px 14px 16px 26px;\n  border: 3px solid @primary-base;\n  color: @secondary-90;\n  background-color: @white;\n  width: 100%;\n\n  &.error {\n    border-color: @invalid-outline;\n  }\n\n  .title-container {\n    width: 100%;\n\n    .title {\n      font-family: Montserrat-Regular, sans-serif;\n      font-size: 18px;\n      text-align: left;\n    }\n\n    .close-circle {\n      width: 24px;\n      height: 24px;\n      object-fit: contain;\n      float: right;\n      background-image: url(../../../styles/img/close-circle.svg);\n      cursor: pointer;\n\n      &:hover {\n        background-image: url(../../../styles/img/close-circle-hover.svg);\n      }\n    }\n\n    .close-cross {\n      width: 24px;\n      height: 24px;\n      object-fit: contain;\n      float: right;\n      background-image: url(../../../styles/img/cross.svg);\n      cursor: pointer;\n\n      &:hover {\n        background-image: url(../../../styles/img/cross-hover.svg);\n      }\n    }\n  }\n\n  .description {\n    width: 100%;\n    font-family: Montserrat-Regular, sans-serif;\n    font-size: 15px;\n    line-height: 1.33;\n    text-align: left;\n  }\n\n  .subtitle {\n    margin-top: 12px;\n    font-family: WarnockPro-Regular, serif;\n    font-size: 15px;\n    text-align: left;\n    color: @secondary-90;\n    display: inline-block;\n    margin-right: 16px;\n  }\n\n  .action-wrap {\n    display: flex;\n    justify-content: flex-end;\n    margin: 10px 5px 0 0;\n\n    .action {\n      width: 70px;\n      height: 35px;\n      background-color: @primary-base;\n      cursor: pointer;\n      text-align: center;\n\n      .text {\n        font-family: WarnockPro-Semibold, serif;\n        font-size: 14px;\n        line-height: 35px;\n        color: @white;\n        text-decoration: none;\n      }\n\n      &:hover {\n        background-color: @primary-hover;\n      }\n    }\n  }\n  &.head {\n    padding-top: 26px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
